import React, { useState, useEffect, useRef } from 'react'

export function ConfirmModal({ config, onClose }) {
  useEffect(() => {
    if (!config) return
    const handler = e => { if (e.key === 'Escape') onClose() }
    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [config, onClose])

  if (!config) return null

  const { message, confirmLabel = 'Delete', danger = true, onConfirm } = config

  const handleConfirm = () => { onConfirm(); onClose() }

  return (
    <div className="ak-overlay" onMouseDown={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className="ak-modal" style={{ maxWidth: 400 }}>
        <div className="ak-modal-body">
          <p style={{ fontSize: 14, color: 'var(--ink)', lineHeight: 1.55, margin: '0 0 1.25rem' }}>{message}</p>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <button className="ak-btn ak-btn--ghost ak-btn--sm" onClick={onClose}>Cancel</button>
            <button
              className="ak-btn ak-btn--sm"
              style={danger
                ? { background: 'var(--c-additional)', color: '#fff', borderRadius: 'var(--radius-ctl)' }
                : { background: 'var(--green)', color: '#fff', borderRadius: 'var(--radius-ctl)' }}
              onClick={handleConfirm}
              autoFocus
            >{confirmLabel}</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export function NameModal({ config, onClose }) {
  const [value, setValue] = useState('')
  const inputRef = useRef(null)

  useEffect(() => {
    if (config) {
      setValue(config.defaultValue || '')
      setTimeout(() => inputRef.current?.focus(), 0)
    }
  }, [config])

  useEffect(() => {
    if (!config) return
    const handler = e => { if (e.key === 'Escape') onClose() }
    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [config, onClose])

  if (!config) return null

  const { title, placeholder = 'Name…', confirmLabel = 'Create', onConfirm } = config

  const handleConfirm = () => {
    if (!value.trim()) return
    onConfirm(value.trim())
    onClose()
  }

  return (
    <div className="ak-overlay" onMouseDown={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className="ak-modal" style={{ maxWidth: 400 }}>
        <div className="ak-modal-head">
          <span className="ak-modal-title">{title}</span>
        </div>
        <div className="ak-modal-body">
          <input
            ref={inputRef}
            className="ak-input"
            style={{ width: '100%', fontSize: 14 }}
            value={value}
            placeholder={placeholder}
            onChange={e => setValue(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter') handleConfirm()
              if (e.key === 'Escape') onClose()
            }}
          />
        </div>
        <div className="ak-modal-foot">
          <button className="ak-btn ak-btn--ghost ak-btn--sm" onClick={onClose}>Cancel</button>
          <button
            className="ak-btn ak-btn--primary ak-btn--sm"
            onClick={handleConfirm}
            disabled={!value.trim()}
          >{confirmLabel}</button>
        </div>
      </div>
    </div>
  )
}
